import type {DistributionBarSection} from './types';

/**
 * Calculate proportional widths with minimum width enforcement.
 * All sections get at least the minimum width so they remain readable,
 * and remaining space is distributed proportionally based on values.
 */
export function calculateProportionalWidths(
    sections: DistributionBarSection[],
    minWidthPercent: number
): number[] {
    const total = sections.reduce((acc, s) => acc + s.value, 0);
    const numSections = sections.length;

    // Reserve minimum width for all sections
    const reservedSpace = numSections * minWidthPercent;
    const distributedSpace = 100 - reservedSpace;

    if (total === 0 || distributedSpace <= 0) {
        // If all values are 0 or no space left to distribute, use equal widths
        return sections.map(() => 100 / numSections);
    }

    // Each section gets: minWidth + proportional share of remaining space
    return sections.map((s) => {
        const proportionalBonus = (s.value / total) * distributedSpace;

        return minWidthPercent + proportionalBonus;
    });
}
